import React from 'react';
import OptionsPanel from 'Components/OptionsPanel/OptionsPanel';
import UserControl from './UserControl/UserControl';
import CollaboratorControl from './CollaboratorControl/CollaboratorControl';
import ExternalCollaboratorControl from './ExternalCollaboratorControl/ExternalCollaboratorControl';
import { useContext } from 'react';
import { AuthContext } from 'Contexts/auth';

const PanelsUserControl = ({
    onUpdateResetUserList,
    onUpdateUserSelected,
    onUpdateSupplierIdSelected,
    supplierIdSelected,
    usersSelected
}) => {
    const { user } = useContext(AuthContext);
    const currentModule = user.module;

    return (
        <>
            <OptionsPanel
                options={[
                    {
                        label: 'Usuário',
                        component: (
                            <UserControl
                                onUpdateResetUserList={val => { onUpdateResetUserList(val) }}
                                onUpdateUserSelected={onUpdateUserSelected}
                                usersSelected={usersSelected}
                            />
                        )
                    },
                    {
                        label: 'Colaborador',
                        component: (
                            <CollaboratorControl
                                onUpdateResetUserList={val => { onUpdateResetUserList(val) }}
                                onUpdateUserSelected={onUpdateUserSelected}
                                usersSelected={usersSelected}
                            />
                        )
                    },
                    ...(currentModule == 'OCMT_PRD_QTRZ' || currentModule == 'OCMT_PRD_BLCT_QTRZ'
                        ? [{
                            label: 'Colaborador externo',
                            component: (
                                <ExternalCollaboratorControl
                                    onUpdateResetUserList={val => { onUpdateResetUserList(val) }}
                                    onUpdateUserSelected={onUpdateUserSelected}
                                    usersSelected={usersSelected}
                                />
                            )
                        }]
                        : [])
                ]}
            />
        </>
    );
};

export default PanelsUserControl;


